import clsx from "clsx";
import { BaseIcon } from "@/shared/icons/BaseIcon";

type Props = {
  icon: typeof BaseIcon;
  color?: "accent" | "gray";
};

export default function PlayerMenuCharacterFadeBox({ icon, color = "gray" }: Props) {
  return (
    <div
      className={clsx(
        "relative flex items-center justify-center w-[3.25rem] aspect-square shrink-0",
        "rounded-[0.75rem] border-2 ",
        {
          "border-accent-muted/20": color === "accent",
          "border-white/5": color === "gray",
        },
      )}
    >
      <div
        className={clsx(
          "w-[2.75rem] aspect-square shrink-0 flex items-center justify-center",
          "rounded-[0.5rem]",
          {
            "bg-accent-muted/10": color === "accent",
            "bg-white/[.05]": color === "gray",
          },
        )}
        style={{
          WebkitMaskImage: "linear-gradient(to bottom, #000000 0%, transparent 80%)",
        }}
      >
        {icon({
          size: 28,
          className: color === "accent" ? "text-accent-solid/60" : "text-white/30",
        })}
      </div>
    </div>
  );
}
